import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Switch, Route, useHistory, withRouter } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import './index.css';
import { select } from 'redux-saga/effects';
import { Avatar, Badge, Card, CardActions, CardContent, CardHeader, ListItemIcon } from '@mui/material';
import { Logout, PersonAdd, Settings } from '@mui/icons-material';
import MailIcon from '@mui/icons-material/Mail';
import { messageActionsSaga } from '../../../../infrastructure/services/message';
import ComentsView from '../../molecula/ComentsView';
import { TypeNotifications } from '../wss/typeNotifications.enum';
import tkLogo from '../../../../utils/img/tkloginBN.png';





const AppBarApp = ({ lassMessageAplication, reviuwMessage, controlReviuwMessage }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [anchorSession, setAnchorSession] = useState(null);
  const [anchorMessage, setAnchorMessage] = useState(null);
  const { name, lastName, roleId, role, nameAcount } = useSelector((store) => store.tk.sesion.user);
  const { connection: connectionGetAll, data: dataGetAll } = useSelector((store) => store.tk.trackingCase.getAll);
  const { connection: connectionGetAllMessage, data: dataGetAllMessage } = useSelector((store) => store.tk.message.getAll);
  const [showComentsView, setShowComentsView] = useState(false);
  const [idComentsView, setIdComentsView] = useState(null);
  const [titleComentsView, setTitleComentsView] = useState(null);
  const [navItems, setNavItems] = useState([
    { item: "Mis Demandas", route: "/actives", select, rolsId: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
    { item: "Demandas Guardadas", route: "/save", rolsId: [1], display:{ xs: 'none', sm: 'inline-flex' } },
    { item: "Gestion Cliente", route: "/clients", rolsId: [1] },
    { item: "Gestion Usuarios", route: "/users", rolsId: [1] },
    //{ item: "Home", route: "home", rolsId: [1, 2, 3, 4, 5, 6, 7, 8, 9] }
  ]);

  const itemsShow = () => {
    return navItems.map((item) => (item.rolsId.some(i => i === roleId) &&
      <Button sx={{display: item.display}} variant={item.select ? "contained" : ""} onClick={() => handleNavigate(item)} key={item.item} disabled={dataGetAll.length === 0 ? connectionGetAll : false}>
        <Box sx={{ color: '#fff', textAlign: 'left !important', width: '100%', fontWeight: 200 }}>{item.item}</Box>
      </Button>
    ))
  }

  const findAllMessages = () => {
    dispatch(messageActionsSaga.getAll())

  }

  const handleMenu = (event) => {
    setAnchorSession(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorSession(null);
  };
  const handleCerrarSesion = () => {
    sessionStorage.clear();
    history.push(`/`);
    window.location.reload(false);
  }


  const handleNavigate = (item) => {
    if (item.route) {
      const set = navItems.map(options => {
        return { ...options, select: item.item === options.item }; // Use spread syntax for immutability
      });
      setNavItems(set)
      sessionStorage.setItem('location', `${item.route}`)
      history.push(item.route);
    }
  }

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawerWidth = 240;

  useEffect(() => {
    findAllMessages()
    const location = sessionStorage.getItem('location')
    if (location) {
      history.push(location);
    } else {
      history.push(`/actives`);
    }
  }, [])

  useEffect(() => {
    const location = history.location.pathname;
    const set = navItems.map(options => {
      return { ...options, select: location === options.route }; // Use spread syntax for immutability
    });
    setNavItems(set)

  }, [history.location.pathnamelo])

  const findComents = (item) => {
    setIdComentsView(item.id)
    setTitleComentsView(`Mensajes de juicio N:${item.cadeCase}`)
    setShowComentsView(true);
    findAllMessages()

  }

  useEffect(() => {
    if (lassMessageAplication && lassMessageAplication.type === TypeNotifications.GETMESSAGES) { findAllMessages() }
  }, [lassMessageAplication]);

  useEffect(() => {
    reviuwMessage && findAllMessages()
    reviuwMessage && controlReviuwMessage(false)
  }, [reviuwMessage])


  const unitAndCount = (array, propiedad) => {
    const mapa = {};
    const resultado = [];

    for (const objeto of array) {
      const clave = objeto[propiedad];
      if (mapa[clave]) {
        mapa[clave].count++;
      } else {
        mapa[clave] = { ...objeto, count: 1 };
        resultado.push(mapa[clave]);
      }
    }

    return resultado;
  }

  return (
    <>
      <AppBar className='AppBar' position="fixed" sx={{backgroundColor:'#4f4f4f'}}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            open={mobileOpen}
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ mr: 0, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          
          <Typography variant="h6" component="span" sx={{ flexGrow: 1 }}>
              <Box className='logo' sx={{paddingTop:.8,maxWidth: { xs: '150px', sm: '210px' }}}><img src={tkLogo} alt="TrackingCase" /></Box>
            
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {itemsShow()}
          </Box>


          {roleId!==10 && (
            <>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={(e) => setAnchorMessage(e.currentTarget)}
              color="inherit"
              disabled={dataGetAllMessage.length === 0}
            >
              <Badge badgeContent={dataGetAllMessage.length} color="primary"><MailIcon color="action" /></Badge>
            </IconButton>
            {dataGetAllMessage.length > 0 && (
              <Menu
                anchorSession={anchorMessage}
                id="account-menu-messajes"
                open={anchorMessage}
                onClose={() => setAnchorMessage(null)}
                onClick={() => setAnchorMessage(null)}
                sx={{pt:0,
                      pb:0,}}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      ml:  {xs: 0, sm: -7.5, md: -7.5 },
                      mt: 5,
                      
                      width:{xs: 'auto', sm: 'auto', md: 'auto' } ,
                      '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: {xs: 65, sm: 14, md: 14 } ,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                {unitAndCount(dataGetAllMessage, 'caseId').map((messaje) => (
                  <MenuItem sx={{p:{xs: 1, sm: 1, md: 1.5 }}} onClick={() => findComents(messaje)}>
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      onClick={(e) => setAnchorMessage(e.currentTarget)}
                      color="inherit"
                      sx={{p:{xs: 0.5, sm: 1, md: 1.5 }}}
                    >
                      <Badge badgeContent={messaje.count} color="primary"><MailIcon color="action" /></Badge>
                    </IconButton>
                    <Typography sx={{ fontWeight: 'bold', fontSize: {xs: 11, sm: 12, md: 14 } }}>{messaje.count > 1 ? 'Tienes mensajes':messaje.userMessanger}</Typography>
                    <Typography sx={{ fontSize: {xs: 11, sm: 12, md: 14 }}}>{', juicio N°: ' }</Typography>
                    <Typography sx={{ pr:1, fontWeight: 'bold', fontSize: {xs: 11, sm: 12, md: 14 } }}>{messaje.cadeCase}</Typography>
                  </MenuItem >
                ))}
              </Menu>
            )}
            </>
          )}

          
            

          
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              anchorSession={anchorSession}
              id="account-menu"
              open={anchorSession}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    ml: -1.5,
                    mt: 5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem onClick={handleClose}>
                <Avatar sx={{ backgroundColor: '#528d71' }}><AccountBalanceIcon sx={{ fontSize: 18 }} /> </Avatar> {nameAcount}
              </MenuItem >
              <MenuItem onClick={handleClose}>
                <Avatar sx={{ backgroundColor: '#528d71' }} ><VerifiedUserIcon sx={{ fontSize: 18 }} /></Avatar> {role}
              </MenuItem >
              <MenuItem onClick={handleClose} >
                <Avatar sx={{ backgroundColor: '#528d71' }} /> {`${name} ${lastName}`}
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleCerrarSesion}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Salir
              </MenuItem>
            </Menu>
         
        </Toolbar>
      </AppBar>
      <Drawer
        anchor={'left'}
        open={mobileOpen}
        onClose={false}
        onClick={handleDrawerToggle}
        PaperProps={{
          sx: {
            backgroundColor: "#4f4f4f",
            fontWeight: 200
          }
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { p: 3, boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        {itemsShow()}
      </Drawer>
      {showComentsView && <ComentsView
        handlerShow={setShowComentsView}
        show={showComentsView}
        cardSelected={{ id: idComentsView, title: titleComentsView }}
        lassMessageAplication={lassMessageAplication}
      />}
    </>

  );
}

export default AppBarApp;